<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
        <el-col :span="8">
          <el-form-item label="状态" prop="state">
            <el-switch v-model="form_data.state" :active-value="1" :inactive-value="0" :disabled="isInfo" active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="适用于单多层" prop="for_multi_story">
            <el-switch v-model="form_data.for_multi_story" :active-value="1" :inactive-value="0" :disabled="isInfo" active-text="适用">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="适用于高层" prop="for_high_rise">
            <el-switch v-model="form_data.for_high_rise" :active-value="1" :inactive-value="0" :disabled="isInfo" active-text="适用">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="私有归属场所类型" prop="type_id" >
              <el-select v-model="form_data.type_id" multiple placeholder="请选择场所类型(可多选)">
                <el-option v-for="item in place_type_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
              </el-select>
            <!-- <el-radio-group v-model="form_data.type_id">
                <el-radio :label="parseInt(item.id)" v-for="(item,index) in place_type_list" :key="index">{{item.name}}</el-radio>
            </el-radio-group> -->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="器材名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="24">
          <el-form-item label="器材缩写" prop="abbreviation">
            <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        </el-col>
          <el-col :span="24">
          <el-form-item label="图片材料字段" prop="place_data_field">
            <el-input v-model="form_data.place_data_field" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="器材图片" prop="photo">
            <l-upload-img method="equipment_upload"  accept=".jpg,.png,.bmp" name="img" :on-success="(res)=>handleUploadSuccess(res,'photo')" :preview-url="photo_preview" :disabled="isInfo">
            </l-upload-img>
          </el-form-item>
        </el-col>
        
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>

export default {
  name: 'l-equipment-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    isInfo: {
      type: Boolean,
      default: false,
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
    place_type_list(){
      return this.$store.state.list.place_type_list;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
          
        }
      }
    },
  },
  data() {
    return {
      photo_preview:"",
      loading: false,//页面是否加载中
      //表单数据
      form_data: {
        type_id: [],
        name: '',
        state:1,
        photo:"",
        abbreviation:"",
        for_multi_story:1,
        for_high_rise:1,
        // place_type_ids: [],
      },
      //表单验证规则
      rules: {
        name: [
          { required: true, message: '内容不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  
    mounted() {
    },

  methods: {
    //上传图标成功后的回调
    handleUploadSuccess(res, field) {
      this.form_data[field] = res.data.photo_url;
      this[field + "_preview"] = res.data.photo;
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e){
      if(this.form_data.type=='' && e){
        this.$alert('请先选择场所类型', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    //获取数据
    getData() {

      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`equipment_edit`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret;
           this.photo_preview = ret.photo;
          // this.tree_node = ret.superior;
          this.getdata_flag=true
        }).finally(() => {
          this.loading = false;
        });

      } else {
        // this.form_data.use_type = this.$props.useType
      }
    },


    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          if(this.form_data.pid==""){
            this.form_data.pid=0
          }
          this.submitting = true;
          if (!this.hasId) {//添加
          // console.log(this.form_data)
          // console.log(typeof this.form_data.is_node)
          // console.log(typeof this.form_data.pid)
          // console.log(typeof this.form_data.type)
            this.$_invoke('equipment_save', this.form_data).then(() => {
              this.$_msg.success('添加成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            this.$_invoke(`equipment_update`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>